export default __webpack_public_path__ + "static/media/tron-trx-logo.ab0b5d93.png";